import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import api from '../lib/api';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const reload = useCallback(async () => {
    try {
      const res = await api.get('/settings');
      setSettings(res.data);
    } catch (e) {
      setSettings({
        company_name: 'TTS - Transporte Turístico Santos',
        address: 'Punta Cana, La Altagracia, República Dominicana',
        phone: '+1 (829) 983-8580',
        email: 'info@tts-santos.com',
        whatsapp_number: '18299838580',
        facebook_url: '',
        instagram_url: '',
        tiktok_url: '',
      });
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const value = useMemo(() => ({ settings, reload }), [settings, reload]);

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  return ctx || { settings: null, reload: () => {} };
};
